import React from 'react';

import './style.css'

const LoadingDots = () => (
  <div className="loading">...</div>
);

export default LoadingDots
